<owl-carousel-o [options]="customOptions" (dragging)="isDragging = $event.dragging">
  <ng-container *ngFor="let carousel of carouselListItems">
    <ng-template [width]="298" carouselSlide>
      <div
        class="container d-flex justify-content-center carousel-slide-container"
        [owlRouterLink]="carousel.redirectUrl"
        [stopLink]="isDragging"
      >
        <div class="d-lg-flex kids-carousel-card-bg">
          <img [src]="carousel.image | contentAssetImage" alt="{{ carousel.key }}" />
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
